import aa from 'search-insights'

/**
 * Sets Insights `authenticatedUserToken` on login; clears it on logout.
 * No-op when logged in but id is not ready yet.
 */
export const syncAlgoliaAuthenticatedUserToken = (
  isLoggedIn: boolean,
  authenticatedId?: string | null
): void => {
  if (!import.meta.client) return

  if (!isLoggedIn) {
    aa('setAuthenticatedUserToken', undefined)
    return
  }

  if (!authenticatedId) return

  aa(
    'setAuthenticatedUserToken',
    String(authenticatedId).replace('auth0|', '')
  )
}
